import * as React from 'react'
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useHomePageContentStore } from 'src/hooks/HomePageContent';
import { Pagination } from 'src/reusable/global';
import Helper from 'src/support/Helper';
import HomePage from '@system/config/home-page';
import CommonContent from '../CommonContent';
import useReduxState from 'src/hooks/useReduxState';
import System from 'src/helper/system';
import NoResultContent from '../NoResultContent';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { __remove, __set } from 'src/store/axios_indicator';
let c = System.getParams();
const AllContentTab = () => {
    const [list, setList] = useState({});
    const [videoList, setVideoList] = useState({});  
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [{ }, { get_all_content_list, get_all_content_video_list }] = useHomePageContentStore();
    const [searchParams] = useSearchParams();
    const [HomePageContentTabList__Component__Loader, Set_HomePageContentTabList__Component__Loader] = useReduxState(searchParams.get(CommonContent.param_key_HomePageContentTabList) ? searchParams.get(CommonContent.param_key_HomePageContentTabList) : CommonContent.default_component.param_value, CommonContent.redux_key_HomePageContentTabList);
    const [__check] = useAxiosIndicatorCheck();
    const [listObj, setListObj] = useState({
        pageCount: 0,
        page: 1,
        limit: 20,
        sortBy: ''
    });
    useEffect(() => {
        const getList = async () => {
            await fetchAPiCall(firstServerCall);
            await setFirstServerCall(false);
        };
        getList();
    }, []);
    useEffect(() => {
        const getList = async () => {
            setTimeout(async () => {
                await fetchAPiCall();
            }, 500);
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.page]);

    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPiCall(firstServerCall)
            } else {
                await defaultPageActive()
            }
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.limit,listObj.sortBy]);



    const defaultPageActive = async () => {
        setListObj({ ...listObj, page: 1 })
    }

    const handlePageClick = async (data) => {
        let here_page = 0
        here_page = data.selected + 1;
        setListObj({ ...listObj, page: here_page })
        Helper.scrollTop();
    };

    const setPageLimit = async (event) => {
        await setListObj({ ...listObj, limit: event.target.value })
    };

    const getTabLink = (singleElement) => {
        return HomePage.getHomeContentTabsListRouteURL({
            ...c,
            [CommonContent.param_key_HomePageContentTabList]: singleElement.param_value
        });
    };

    const switchTab = async (url, chain_single) => {
        history.pushState('', '', url);
        Set_HomePageContentTabList__Component__Loader(chain_single.param_value);
    };

    const fetchAPiCall = async (
        defaultStart = false) => {
        __set("CONTENT_API_CALL");
        let search_keyword = searchParams.get('search')
        const data = await get_all_content_list({
            "page": defaultStart ? 1 : listObj.page,
            "limit": listObj.limit,
            "sort": listObj.pagesortBy,
            "searchParam": search_keyword
        })
        if (data !== undefined &&
            data !== null &&
            data.data.allContentList !== undefined &&
            data.data.allContentList !== null &&
            data.data.allContentList.length > 0) {
            const total = data.data.totalContentList;
            setListObj({ ...listObj, pageCount: Math.ceil(total / listObj.limit) })
            setList(data.data.allContentList);
        }
        // Set Video List
        const listVideo = await get_all_content_video_list({
            "page": defaultStart ? 1 : listObj.page,
            "limit": 4, // static value has been assigned for video
            "searchParam": search_keyword,
            "pageType": 'All'
        });
        if (listVideo !== undefined &&
            listVideo !== null &&
            listVideo.data !== undefined &&
            listVideo.data !== null &&
            listVideo.data.allContentVideoList !== undefined &&
            listVideo.data.allContentVideoList !== null &&
            listVideo.data.allContentVideoList.length > 0) {
            setVideoList(listVideo.data.allContentVideoList);
        }
        __remove("CONTENT_API_CALL");
    };
    const onFilter = (e) => {
        setListObj({ ...listObj, page: 1,sortBy:e.target.value })

    }

    async function videoTabRedirection() {
        Helper.scrollTop();
        return switchTab(getTabLink(CommonContent.chain_HomePageContentTabList.VDO.param_value), CommonContent.chain_HomePageContentTabList.VDO);
    }

    return (
        <div id="contentTypeAllContent" className="tab-pane fade in active">
            <div className='new-content-wrapper'>
                <div className='bs5 row'>
                    <div className='col-lg-9 tab-data'>
                        <div className='all-content'>
                            <div className='all-content-header'>
                                <div className="bs5 row mt-1">
                                    <div className="col-auto">
                                        <div className='font-oswald font-light font-30'>ALL CONTENT</div>
                                    </div>
                                    {list !== undefined && list !== null && Object.entries(list).length > 0 &&
                                        <div className="col-auto ms-auto align-self-end">
                                            <div className='d-flex align-items-center'>
                                                <label className='mb-0 me-3'>Sort By:</label>
                                                <div className="selectbox">
                                                    <select className="form-control form-control-xs w210" onChange={(e) => onFilter(e)}>
                                                        <option value=''>Relevance </option>
                                                        <option value='asc'>Name - A to Z</option>
                                                        <option value='desc'>Name - Z to A</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <hr />
                            <div className='position-relative'>
                                <div>
                                    {__check(['CONTENT_API_CALL'], { overlay: true }).render}
                                </div>
                                <div className='all-content-body'>

                                    {list !== undefined && list !== null && Object.entries(list).length > 0 &&
                                        list.map((v, i) => (
                                            <React.Fragment key={i}>
                                                <div className='all-content-body-item'>
                                                    {v['pageType'].toLowerCase() === 'article' ?
                                                        <>
                                                            <div className='bs5 row mx-0'>
                                                                <div className='col-lg-9 col-md-12 ps-0 mb-3 mb-lg-0'>
                                                                    <div className='font-16 text-blue2 font-bold mb-1'><span><a href={v['url']} target="_blank">{v['name']}</a></span><span className='content-tag'>{v['pageType']}</span></div>
                                                                    <div>{v['date']}</div>
                                                                    <div className='ellipses mb-1' title="">
                                                                        {v['shortDesc']}
                                                                    </div>
                                                                    {v['shortDesc'] !== undefined &&
                                                                        v['shortDesc'] !== null &&
                                                                        v['shortDesc'] !== '' &&
                                                                        v['shortDesc'].length > 140 &&
                                                                        <a href={v['url']} className="text-blue2 d-block" target='_blank'>Read More</a>
                                                                    }
                                                                </div>
                                                                <div className='col-lg-3 col-md-12 ps-0 text-start text-lg-end'>
                                                                    <div className='new-content-img'>
                                                                        <img className='img-fluid articleimage' src={v['imageUrl']} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </> :
                                                        <>
                                                            <div className='bs5 row'>
                                                                <div className='col-lg-12'>
                                                                    <div className='font-16 text-blue2 font-bold mb-1'><span><a href={v['url']} target='_blank'>{v['name']}</a></span><span className='content-tag'>{v['pageType']}</span></div>
                                                                    <div className='ellipses' title="">
                                                                        {v['shortDesc']}
                                                                    </div>
                                                                    {v['shortDesc'] !== undefined &&
                                                                        v['shortDesc'] !== null &&
                                                                        v['shortDesc'] !== '' &&
                                                                        v['shortDesc'].length > 140 &&
                                                                        <a href={v['url']} className="text-blue2 d-block" target='_blank'>Read More</a>
                                                                    }
                                                                    {v['pageType'].toLowerCase() === 'events' &&
                                                                        <div className="date-location-box mt-2">
                                                                            <div className="date-location-item">
                                                                                <b>Date:&nbsp;</b>  {v['eventDate']}
                                                                            </div> <br />
                                                                            <div className="date-location-item">
                                                                                <b>Location:&nbsp;</b> {v['location']}
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </>
                                                    }
                                                    <hr />
                                                </div>
                                                {/* Video */}
                                                {videoList !== undefined &&
                                                    videoList !== null &&
                                                    videoList.length > 0 &&
                                                    i == 2 && listObj.page === 1 &&
                                                    <div className='all-content-body-item'>
                                                        <div className='bs5 row mx-0'>
                                                            {videoList.filter(x => x.url != '').map((j, k) => (
                                                                <div className='col-auto px-0 mb-3 mb-lg-0'>
                                                                    <div className='video-block'>
                                                                        <div className='video-iframe'>
                                                                            <iframe src={j['url']}
                                                                                frameborder='0'
                                                                                allow='autoplay; encrypted-media'
                                                                                allowfullscreen="allowfullscreen"
                                                                                title='video'
                                                                                width={200}
                                                                            />
                                                                        </div>
                                                                        <a href={j['url']} target="_blank" className='text-blue2 font-bold'>{j['name']}</a>
                                                                        <div className='mb-1' title="">
                                                                            {j['longDesc']}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))
                                                            }
                                                        </div>
                                                        {videoList.length === 4 &&
                                                            <div className='mt-4 '>
                                                                <button className='bs5 btn btn-secondary w200' onClick={() => videoTabRedirection()}>See All Videos</button>
                                                            </div>
                                                        }
                                                        <hr />
                                                    </div>
                                                }

                                            </React.Fragment>
                                        ))
                                    }
                                    {(list === null || Object.entries(list).length === 0) && videoList !== undefined &&
                                        videoList !== null &&
                                        videoList.length > 0 &&
                                        listObj.page === 1 &&
                                        <div className='all-content-body-item'>
                                            <div className='bs5 row mx-0'>
                                                {videoList.filter(x => x.url != '').map((j, k) => (
                                                    <div className='col-auto px-0 mb-3 mb-lg-0'>
                                                        <div className='video-block'>
                                                            <div className='video-iframe'>
                                                                <iframe src={j['url']}
                                                                    frameborder='0'
                                                                    allow='autoplay; encrypted-media'
                                                                    allowfullscreen="allowfullscreen"
                                                                    title='video'
                                                                    width={200}
                                                                />
                                                            </div>
                                                            <a href={j['url']} target="_blank" className='text-blue2 font-bold'>{j['name']}</a>
                                                            <div className='mb-1' title="">
                                                                {j['longDesc']}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                                }
                                            </div>
                                            {videoList.length === 4 &&
                                                <div className='mt-4 '>
                                                    <button className='bs5 btn btn-secondary w200' onClick={() => videoTabRedirection()}>See All Videos</button>
                                                </div>
                                            }
                                            <hr />
                                        </div>
                                    }
                                    {firstServerCall === false && (list === undefined || list === null || Object.entries(list).length === 0) &&
                                        (videoList === undefined || videoList === null || Object.entries(videoList).length === 0) &&
                                        searchParams.get('search') !== undefined && searchParams.get('search') !== null && searchParams.get('search') !== '' &&
                                        <NoResultContent message={'No Results Found for <b>"' + searchParams.get('search') + '"</b>'} />
                                    }
                                </div>
                                {list !== undefined && list !== null && Object.entries(list).length > 0 &&
                                    <div className="pagination-row mt-5">
                                        <Pagination pageCount={listObj.pageCount} handlePageClick={handlePageClick} setPageLimit={setPageLimit} page={listObj.page - 1} limit={listObj.limit} />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-3 tab-sidebar'>
                        <div className='m-b-20' id="espotImg">
                        </div>
                        <div className='newsletter m-b-20'>
                            <div className='newsletter-title font-24 font-bold font-apercu'>Newsletter</div>
                            <p className='m-b-15 text-black'>Subscribe for online delivery</p>
                            <a className='bs5 btn btn-primary w135'>Sign up now</a>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    )
}

export default AllContentTab